import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../..'
import {
  CreateInventoryRequest,
  Inventory,
  ProductById,
  Product,
  UpdateInventoryRequest,
} from './type'
import { Warehouses } from '../warehouses/types'

export class InventoryService {
  static getInventory(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Inventory[]>> {
    return apiService.get<AxiosResponse<Inventory[]>>(`/inventory`, config)
  }

  static getProducts(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Product[]>> {
    return apiService.get<AxiosResponse<Product[]>>(`/products`, config)
  }

  static getWarehouses(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Warehouses[]>> {
    return apiService.get<AxiosResponse<Warehouses[]>>(`/warehouses`, config)
  }

  static getProductById(id: string): Promise<AxiosResponse<ProductById>> {
    return apiService.get<AxiosResponse<ProductById>>(`/products/${id}`)
  }

  static createInventory(data: CreateInventoryRequest): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>(`/inventory`, data)
  }

  static getInventoryById(
    inventoryId?: string,
  ): Promise<AxiosResponse<Product>> {
    return apiService.get<AxiosResponse<Product>>(`inventory/${inventoryId}`)
  }

  static deleteInventory(id: string): Promise<AxiosResponse> {
    return apiService.delete<AxiosResponse>(`/inventory/${id}`)
  }

  static updateInventoryState(
    data: UpdateInventoryRequest,
  ): Promise<AxiosResponse> {
    return apiService.put<AxiosResponse>(`/inventory/${data.id}`, {
      state: data.state,
      variations: data.variations,
    })
  }
}
